import { DocumentsFilters } from '../../../models';
import { createAction, props } from '@ngrx/store';

export const modifyDocumentsFilters = createAction(
    '[DocumentsFilters] modify documentsFilters' , 
    props<{ documentsFilters: DocumentsFilters }>()
);